import axios from "axios";

const sendNotificationCall = async (data, image_En_Data, image_Ar_Data) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/sendNotification`;
  const apiKey = "hawash";

  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    
    if (image_En_Data && image_En_Data !== "undefined" && image_En_Data !== "") {
      formData.append("image_en", image_En_Data);
    }
    if (image_Ar_Data && image_Ar_Data !== "undefined" && image_Ar_Data !== "") {
      formData.append("image_ar", image_Ar_Data);
    }

    const headers = {
      "Content-Type": "multipart/form-data",
      "x-api-key": apiKey,
    };

    const response = await axios.post(url, formData, { headers });
    if (response.data.success) {
      return "تم إرسال الإشعار بنجاح";
    }
    return false;
  } catch (error) {
    return false;
  }
};

export default sendNotificationCall;
